// src/Store/Slice/OtpAuthSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fromType: "customer",
  //   method: "phone",
  phone: "",
  nationalCode: "",
  isExist: false,
  tempToken:""
};

const otpAuthSlice = createSlice({
  name: "otpAuth",
  initialState,
  reducers: {
    updateOtpAuth(state, action) {
      // action.payload can be:
      // { phone }
      // { nationalCode }
      // { phone, nationalCode }
      Object.assign(state, action.payload);
    },
    resetOtpAuth() {
      return initialState;
    },
  },
});

export const { updateOtpAuth } = otpAuthSlice.actions;
export default otpAuthSlice.reducer;
